import { LyraAuthHeaders } from '@lyra/core/constants/api'
import { RfqQuote } from '@lyra/web/constants/rfqs'
import { fetchRfqQuotes } from '@lyra/web/utils/client/fetchRfqQuotes'
import getAuthHeaders from '@lyra/web/utils/getAuthHeaders'
import { useMemo } from 'react'
import useSWR from 'swr'

import useAuth from './useAuth'
import useSubaccount from './useSubaccount'

const EMPTY: RfqQuote[] = []

const fetcher = async (subaccountId: number | undefined, authHeaders: LyraAuthHeaders | null) => {
  if (!authHeaders || !subaccountId) {
    return EMPTY
  }
  return await fetchRfqQuotes(subaccountId, authHeaders)
}

export default function useRfqSentQuotes() {
  const { user } = useAuth()
  const { subaccount } = useSubaccount()
  const subaccountId = subaccount?.subaccount_id
  const authHeaders = user ? getAuthHeaders(user) : null
  const { data, error, isValidating, mutate } = useSWR(
    subaccountId && authHeaders ? ['RfqSentQuotes', subaccountId, authHeaders] : null,
    () => fetcher(subaccountId, authHeaders),
    {
      revalidateIfStale: false,
      revalidateOnMount: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      keepPreviousData: true,
    }
  )
  return useMemo(() => {
    return {
      data: data ?? EMPTY,
      isLoading: isValidating,
      isError: error,
      mutate,
    }
  }, [data, isValidating, error, mutate])
}
